import axios from '../util/axios'

// 获取站内信未读数
export function countLogUnreads (params) {
  return axios({
    url: '/front/notice/countLogUnreads',
    method: 'get',
    data: null
  })
}

// 按照推送类型站内信推送list
export function getNoticeLogList (params = {}) {
  return axios({
    url: '/front/notice/pushStationLogBySendType/list',
    method: 'post',
    data: params
  })
}

// 获取站内信推送日志详情
export function stationLogDetail (params) {
  return axios({
    url: '/front/notice/stationLogDetail/' + params,
    method: 'get',
    data: null
  })
}

// 设站内信为已读
export function setStationRead (params) {
  return axios({
    url: '/front/notice/setStationRead/' + params,
    method: 'get',
    data: null
  })
}

// 获取推送类型
export function getNewLogBySendType (params = {}) {
  return axios({
    url: '/front/notice/getNewLogBySendType/list',
    method: 'post',
    data: params
  })
}

// 设某类型站内信为已读
export function setReadsByType (params) {
  return axios({
    url: '/front/notice/setReadsByType/{sendType}?sendType=' + params,
    method: 'get',
    data: null
  })
}

// 删除某类型站内信
export function deleteBySendType (params = {}) {
  return axios({
    url: '/front/notice/deleteBySendType',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/notice.js